import { render, staticRenderFns } from "./MoleculePopupResults.vue?vue&type=template&id=4f4c49ab&scoped=true&"
import script from "./MoleculePopupResults.vue?vue&type=script&lang=js&"
export * from "./MoleculePopupResults.vue?vue&type=script&lang=js&"
import style0 from "./MoleculePopupResults.vue?vue&type=style&index=0&id=4f4c49ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4c49ab",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesProjectMoleculePopupResult: require('/app/components/molecules/project/MoleculePopupResult.vue').default})
